import DuplicatePINPlateSearch from './duplicate-pin-plate-search';
import t from 'tcomb';

const DuplicatePINPlateSearchCollections = t.list(DuplicatePINPlateSearch, 'DuplicatePINPlateSearch');

export const getDefaultState = () => new DuplicatePINPlateSearchCollections(
    [],
);
export default DuplicatePINPlateSearchCollections;
